import { useState } from 'react';

import { avatarInitials } from '@/lib/format';
import { useCurrentUserQuery } from '@/features/user/queries';

export function UserBadge() {
  const { data, isPending, isError } = useCurrentUserQuery();
  const [imageError, setImageError] = useState(false);

  if (isPending) {
    return (
      <div className="user-badge" aria-hidden="true">
        <span className="user-badge__avatar" />
        <span className="user-badge__text">
          <span className="skeleton" style={{ width: '96px' }} />
        </span>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="user-badge" style={{ cursor: 'pointer' }} onClick={() => {
        window.location.href = '/login';
      }}>
        <span className="user-badge__avatar" aria-hidden="true">
          ?
        </span>
        <span className="user-badge__text">
          <span className="user-badge__name">Требуется вход</span>
          <span className="user-badge__meta" style={{ color: 'var(--accent)' }}>Нажмите для входа</span>
        </span>
      </div>
    );
  }

  const name = data.name?.trim() ? data.name.trim() : null;
  const email = data.email?.trim() ? data.email.trim() : null;
  const primary = name ?? email ?? 'Без имени';
  const secondary = name !== null && email !== null ? email : null;
  const avatarUrl = data.avatarUrl?.trim() ? data.avatarUrl.trim() : null;
  const showImage = avatarUrl && !imageError;

  return (
    <div className="user-badge" title={[primary, secondary].filter(Boolean).join('\n')}>
      <span className="user-badge__avatar" aria-hidden="true">
        {showImage ? (
          <img
            src={avatarUrl}
            alt={primary}
            onError={() => setImageError(true)}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              borderRadius: 'inherit',
            }}
          />
        ) : (
          avatarInitials(name, email)
        )}
      </span>
      <span className="user-badge__text">
        <span className="user-badge__name">{primary}</span>
        {secondary !== null ? <span className="user-badge__meta">{secondary}</span> : null}
      </span>
    </div>
  );
}
